<template>
  <section class="hot home-section bg-gradient pd-both container" id="hot">
    <h2 class="row-title1 ph-text" v-if="loading">■■■■■■■■■■■■</h2>
    <h2 class="row-title1" v-else>Trending Now</h2>
    <ul class="card-master no-bullet" v-if="loading">
      <li class="js-newpage"
        @click.prevent=""
        v-for="index in 5"
      >
        <div class="is-card is-card__primary round-md js-imgcolor-bg js-loading js-newpage"
          v-if="index === 1"
        >
          <a class="has-icon icon-lb" href=""
            @click.prevent=""
          >
            <img class="round-md" :src="constants.phImg600x600" alt="">
          </a>
          <div class="txt center-align">
            <h3 class=""><a href="" class="ph-text"
              @click.prevent=""
            >■■■■■■■■■■■■■■■■■■■■■■■■</a></h3>
            <div class="quiet small">
              <time datetime="" class="ph-text">■■■■■■■■</time>
              <span class="duration ph-text">■■■■■■■</span>
            </div>
          </div>
        </div>
        <a class="has-icon icon-lb" href=""
          @click.prevent=""
          v-if="index !== 1"
        >
          <img class="round-sm" :src="constants.phImg300x300" alt="">
        </a>
        <div class="txt"
          v-if="index !== 1"
        >
          <h3 class="h3"><a href="" class="ph-text"
            @click.prevent=""
          >■■■■■■■■■■■</a></h3>
          <div class="quiet small"><span class="duration ph-text">■■■■■■</span></div>
        </div>
      </li>
    </ul>
    <ul class="card-master no-bullet" v-else>
      <li class="js-newpage"
        @click.prevent="navigatorPush('Episode', { id: episode.id, title: episode.title })"
        v-for="(episode, index) in trendingEpisodes"
        :key="episode.id"
      >
        <div class="is-card is-card__primary round-md js-imgcolor-bg js-loading js-newpage"
          v-if="index === 0"
        >
          <a class="has-icon icon-lb" href=""
            @click.prevent=""
          >
            <img-with-placeholder class="round-md" :src="constants.phImg600x600" :data-src="sizeImg(episode.image_base_url, 600, 600)" :alt="episode.image.alt_text" v-if="episode.image" />
            <img-with-placeholder class="round-md" :src="constants.phImg600x600" :data-src="sizeImg(episode.channel.image_base_url, 600, 600)" :alt="episode.channel.image.alt_text" v-else />
            <span class="play icon icon-md">
              <icon-play />
            </span>
          </a>
          <div class="txt center-align">
            <h3 class=""><a href=""
              @click.prevent=""
            >{{ episode.title }}</a></h3>
            <div class="quiet small">
              <time :datetime="timestampToDate(episode.published_at)">{{ episode.published_at | timestampHumanizeFromNow | titleize }}, </time>
              <span class="duration">{{ episode.duration | secondsToDuration }}</span>
            </div>
          </div>
        </div>
        <a class="has-icon icon-lb" href=""
          @click.prevent=""
          v-if="index !== 0"
        >
          <img-with-placeholder class="round-sm" :src="constants.phImg300x300" :data-src="sizeImg(episode.image_base_url, 300, 300)" :alt="episode.image.alt_text" v-if="episode.image" />
          <img-with-placeholder class="round-sm" :src="constants.phImg300x300" :data-src="sizeImg(episode.channel.image_base_url, 300, 300)" :alt="episode.channel.image.alt_text" v-else />
          <span class="play icon icon-md">
            <icon-play />
          </span>
        </a>
        <div class="txt"
          v-if="index !== 0"
        >
          <h3 class="h3"><a href=""
            @click.prevent=""
          >{{ episode.title }}</a></h3>
          <div class="quiet small"><span class="duration">{{ episode.duration | secondsToDuration }}</span></div>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  props: ['loading', 'trendingEpisodes'],
};
</script>
